import React, { useState, useReducer, useContext, useEffect } from 'react';

import { initialStreamFormState } from './constant';
import { convertToBase64 } from '../../utils/index';
import { AuthContext } from "../../context/auth/authContext";
import { ApiContext } from "../../context/api/apiContext";
import { CHANNEL_API } from '../../api/channel/index';
import { useAlert } from '../Alert/useAlert';

// Components
import Spinner from '../Spinner/Spinner';
import Alert from '../Alert/Alert';
import Artist from '../Artist/Artist';
import FormInput from '../FormInput/FormInput';

const StreamForm = ({ streamId, isEditStreamPage }) => {
	const [inputImageFile, setInputImageFile] = useState(null);
	const [isEventLoading, setEventLoading] = useState(false);
	const [inputValues, setInputValues] = useReducer(
		(state, newState) => ({ ...state, ...newState }), initialStreamFormState);
	const { currentUser } = useContext(AuthContext);
	const { getUser, addEvent, updateEvent, deleteEvent, events } = useContext(ApiContext);
	const [alert, showAlert, hideAlert ] = useAlert();

	const handleOnChange = async event => {
		const target = event.target;
		const { name, value } = target;

		if (target.files && target.files[0]) {
			let imageFile = await convertToBase64(target.files[0]);
			setInputValues({ [name]: target.files[0] });
			setInputImageFile(imageFile);
		} else {
			setInputValues({ [name]: value });
		}

	};

	const showUploadError = (message) => {
		setEventLoading(false);
		showAlert(message, 'danger');
	};

	const removeEvent = id => {
		setEventLoading(true);
		deleteEvent(id);
	};

	const createEvent = accountId => {
		const { artist, title, startDate, ticketPrice, description } = inputValues;

		const event = new FormData();

		event.append('uploadedfile', inputValues.userFile, 'filename.jpg');
		event.append('event_id', streamId);
		event.append('account_id', accountId);
		event.append('artist', artist);
		event.append('title', title);
		event.append('enabled', 1);
		event.append('price', ticketPrice);
		event.append('description', description);
		event.append('start_date', startDate);
		event.append('uploadedfile', inputValues.userFile);

		return event;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			setEventLoading(true);

			const userInfo = await getUser();
			const event = createEvent(userInfo.data.account_id);

			if (isEditStreamPage) {
				const event = events.filter(item => {
					return item.id == streamId;
				});

				const media = {
					id: event[0].id,
					account_id: userInfo.data.account_id
				};

				await CHANNEL_API.deleteMedia(media, currentUser.token);
			}

			if (isEditStreamPage) {
				await updateEvent(event, showAlert)
			} else {
				const res = await addEvent(event, showAlert);
				if (!res) {
					setEventLoading(false);
				}
			}

		} catch (e) {
			showUploadError(e.message);
		}

	};

	return (
		<form className="edit_form" onSubmit={handleSubmit}>
			<Artist
				cssMod='offset_mod'
				changeButton={true}
				channel={inputValues.artist}
				artist={inputValues.title}
				day={inputValues.startDate}
				handleOnChange={handleOnChange}
				inputImageFile={inputImageFile}
				isEventLoading={isEventLoading}
			/>
			<div className="edit_form_in">
				<div className="reach_form">
					<div className="reach_form_controller offset_mod full_mod">
						<FormInput
							title="ARTIST"
							id="artist"
							type="text"
							name="artist"
							placeholder=""
							required={true}
							onChange={handleOnChange}
							editCssMod
							showLabelCssMod
						/>
					</div>
					<div className="reach_form_controller offset_mod full_mod">
						<FormInput
							title="TITLE"
							id="title"
							type="text"
							name="title"
							placeholder=""
							required={true}
							onChange={handleOnChange}
							editCssMod
							showLabelCssMod
						/>
					</div>
					<div className="reach_form_controller offset_mod full_mod">
						<FormInput
							title="SUBTITLE"
							id="subtitle"
							type="text"
							name="subtitle"
							placeholder=""
							onChange={handleOnChange}
							editCssMod
							showLabelCssMod
						/>
					</div>
					<div className="reach_form_controller offset_mod">
						<FormInput
							title="START DATE"
							id="startDate"
							type="text"
							name="startDate"
							placeholder=""
							required={true}
							onChange={handleOnChange}
							editCssMod
							showLabelCssMod
							dateType
						/>
					</div>
					<div className="reach_form_controller offset_mod">
						<FormInput
							title="END DATE"
							id="endDate"
							type="text"
							name="endDate"
							placeholder=""
							onChange={handleOnChange}
							editCssMod
							showLabelCssMod
							dateType
						/>
					</div>
					<div className="reach_form_controller offset_mod full_mod">
						<FormInput
							title="Ticket price"
							id="ticketPrice"
							type="text"
							name="ticketPrice"
							placeholder=""
							maxLength={6}
							onChange={handleOnChange}
							required={true}
							editCssMod
							showLabelCssMod
						/>
					</div>
					<div className="reach_form_controller offset_mod full_mod">
						<FormInput
							title="Description"
							id="description"
							type="text"
							name="description"
							placeholder=""
							textarea
							onChange={handleOnChange}
							editCssMod
							showLabelCssMod
						/>
					</div>
				</div>
				<div className="btn_w center_level_mod">
					<button
						className="btn_stream"
						type="submit"
						value="Submit"
						disabled={isEventLoading}
					>
						{isEventLoading ? (
							<Spinner />
						) : isEditStreamPage ? 'Modify Stream' : 'Create Stream'}
					</button>
					{isEditStreamPage ? (
						<button
							className="btn_remove offset_mod"
							disabled={isEventLoading}
							onClick={() => removeEvent(streamId)}
						>Remove Stream</button>
					): null}
				</div>
			</div>
			{alert.visible ? (
				<Alert
					alert={alert}
					hide={hideAlert}
					streamFormMod
				/>
			) : null}
		</form>
	);
}
export default StreamForm;